/** @format */

import React, { Component } from 'react';
import { Segment, Header, Grid, Statistic, Divider } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';

@inject('StatsStore')
@observer
class StatsOverview extends Component {
  render() {
    const { StatsStore } = this.props;
    const { counters } = StatsStore.stats;
    return (
      <Segment textAlign="center">
        <Header as="h3" children="Overview Economica" />
        <Divider />
        <Grid columns="3">
          <Grid.Row>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>
                  {counters.totalSalesValue.toFixed(2)}€
                </Statistic.Value>
                <Statistic.Label>Ricavi Totali</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>
                  {counters.soldItemsAverageValue.toFixed(2)}€
                </Statistic.Value>
                <Statistic.Label>Valore Medio Vendita</Statistic.Label>
              </Statistic>
            </Grid.Column>
            <Grid.Column textAlign="center">
              <Statistic size="mini">
                <Statistic.Value>
                  {(counters.totalSalesValue / counters.counter).toFixed(2)}€
                </Statistic.Value>
                <Statistic.Label>Valore Medio Richiesta</Statistic.Label>
              </Statistic>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default StatsOverview;
